// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textWithHighlightComponent[data-v-db23e9ec]{position:relative}.textWithHighlightComponent[data-v-db23e9ec],.textWithHighlightComponent span[data-v-db23e9ec]{overflow:hidden;text-overflow:ellipsis}.highlight[data-v-db23e9ec]{background-color:#efefef}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
